export enum ModalType {
  PaymentPending = 'PaymentPending',
  PaymentFailed = 'PaymentFailed',
  OrderValidating = 'OrderValidating',
  OrderValidationFailed = 'OrdervalidationFailed',
  OrderConfirming = 'OrderConfirming',
  OrderConfirmationFailed = 'OrderConfirmationFailed',
}
